import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X } from "lucide-react";

const TabBar = ({ openTabs, onClose }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="flex h-9 shrink-0 items-stretch overflow-x-auto bg-vscode-panel">
      {openTabs.map((tab) => {
        const active = pathname === tab.path;
        const Icon = tab.icon;
        return (
          <div
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`group flex min-w-[9rem] cursor-pointer items-center gap-2 border-r border-vscode-border px-3 text-xs ${
              active
                ? "bg-vscode-bg text-vscode-textBright border-t-2 border-t-vscode-accent"
                : "bg-vscode-panelAlt text-vscode-textMuted border-t-2 border-t-transparent hover:text-vscode-text"
            }`}
          >
            <Icon size={14} strokeWidth={1.5} />
            <span className="truncate">{tab.label}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onClose(tab.path);
              }}
              title="Close"
              className="ml-auto rounded-sm p-0.5 opacity-0 hover:bg-vscode-listHover group-hover:opacity-100"
            >
              <X size={13} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default TabBar;
